<template>
  <div class="Page">
    <HeaderSection 
      title="StagePlaatsen"
      :closeLinkTo="{ name: 'home' }">
      <p>
        - Impact, diversiteit, netwerk mogelijkheden &amp; verantwoordelijkheden.<br />
        - Foto Bart &amp; Frank
      </p>
    </HeaderSection>
    <ContentSection>
      <p>
        ... Verwachtingen &amp; wat wil je verbeteren ? ...
      </p>
      <Link 
        arrow
        :to="{name: 'page-contact'}" 
        label="Stuur je CV en motivatie brief" />
    </ContentSection>
    <ContentSection>
      <SectionHeader label="Stage Plaatsen" />
      <ContentTip>
        <strong>HBO - Geo Media &amp; Design</strong>
      </ContentTip>
      <br />
      <ContentTip>
        <strong>HBO - Journalistiek</strong> 
      </ContentTip>
      <br />
      <ContentTip>
        <strong>HBO - Web Ontwikkeling</strong> 
      </ContentTip>
    </ContentSection>

    <ContentSection>
      <SectionHeader label="Ervaringen" />
      <h3>Bart (Geo Media Design)</h3>
      <p>... <br />+ LinkedIn link</p>
      <h3>Frank (Geo Media Design)</h3>
      <p>... <br />+ LinkedIn link</p>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/section/ContentSection';
import HeaderSection from '@/components/section/HeaderSection';
import SectionHeader from '@/components/section/Header';
import ContentTip from '@/components/content/Tip';
import Link from '@/components/Link';

export default {
  name: 'PageStagePlaatsen',
  components: {
    HeaderSection,
    ContentSection,
    ContentTip,
    SectionHeader,
    Link
  }
}
</script>
